// Route gate for the voice-assistants module. Open to super-admins (who provision
// the Motor de Voz keys) AND to any org that already has an active account — so a
// provisioned org sees the module without needing super-admin. On top of that,
// the org's RBAC must grant the `voice_assistants` key (legacy users without a
// role_id pass via the has_permission fallback; super-admins always pass).
import { Navigate, Outlet } from "react-router-dom";
import { useSuperAdmin } from "@/hooks/useSuperAdmin";
import { usePermissions } from "@/hooks/usePermissions";
import { useRetellAccount } from "@/voice-assistants/hooks/use-retell-account";
import { APP_HOME_PATH } from "@/lib/copilot-home";

export function VoiceAssistantsGuard() {
  const { isSuperAdmin, loading: saLoading } = useSuperAdmin();
  const { hasAccount, loading: accLoading } = useRetellAccount();
  const { can, firstAllowedPath } = usePermissions();

  // Super-admins are in regardless of the account fetch; everyone else needs a key.
  // Render nothing while checking — a visible "Verificando acceso..." flash reads
  // as a glitch given the fade-in transition between routes.
  if (saLoading) return null;
  if (isSuperAdmin) return <Outlet />;
  if (accLoading) return null;
  if (!hasAccount) return <Navigate to={APP_HOME_PATH} replace />;
  if (!can("voice_assistants")) return <Navigate to={firstAllowedPath} replace />;
  return <Outlet />;
}
